@if (isInitialized) {
  <div class="pricing-model-options" [class.reversed]="isDailyRateDefault">
    <button
      id="selectHourlyPricing"
      class="btn btn-default"
      [class.simple]="simpleMode"
      [class.selected]="(pricingModel | async) === 'hourly'"
      (click)="setPricingModel('hourly')"
    >
      @if (simpleMode) {
        <div class="btn-title-lg" [class.margin-bottom]="hourlyRate">
          {{ 'PRICING_MODEL_HOURLY' | translate }}
        </div>
      }
      @if (simpleMode && hourlyRate) {
        <div class="btn-desc-lg">
          {{ hourlyRate | price: currency }}/{{ 'HOUR' | translate }}/{{ 'BAG' | translate | lowercase }}
        </div>
      }
      @if (!simpleMode) {
        <div class="btn-title">{{ 'PAY_AS_YOU_GO' | translate }}</div>
      }
      @if (!simpleMode) {
        <div class="btn-desc">{{ 'PAY_AS_YOU_GO_EXPLANATION' | translate }}</div>
      }
    </button>
    <button
      id="selectDailyPricing"
      class="btn btn-default"
      [class.simple]="simpleMode"
      [class.selected]="(pricingModel | async) === 'daily'"
      (click)="setPricingModel('daily')"
    >
      @if (simpleMode) {
        <div class="btn-title-lg" [class.margin-bottom]="dailyRate">
          {{ 'PRICING_MODEL_DAILY' | translate }}
        </div>
      }
      @if (simpleMode && dailyRate) {
        <div class="btn-desc-lg">
          {{ dailyRate | price: currency }}/{{ 'DAY' | translate }}/{{ 'BAG' | translate | lowercase }}
        </div>
      }
      @if (!simpleMode) {
        <div class="btn-title">{{ 'FLAT_RATE' | translate }}</div>
      }
      @if (!simpleMode) {
        <div class="btn-desc">{{ 'FLAT_RATE_EXPLANATION' | translate }}</div>
      }
    </button>
  </div>
}
